import FilterListIcon from '@mui/icons-material/FilterList';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import {useState} from 'react';
import {AutoCompleteGetTag} from '../../../components/models/media_tags/AutoCompleteGetTag';
import {UserCanAny} from '../../../components/UserCan';
import {ITag} from '../../../dto/MediaTrack.dto';

type Props = {
  tag?: ITag | null;
  setTag?: (val: ITag | null) => void;
  school_ids?: number[];
  event_type_ids?: number[];
  station_id?: number[];
  handleSelectAll: (e: React.ChangeEvent<HTMLInputElement>) => void;
  allSelected: boolean;
  type?: string;
};
const AdminFilterOnly = ({
  tag,
  setTag,
  school_ids = [],
  event_type_ids = [],
  handleSelectAll,
  allSelected,
  station_id = [],
  type = '',
}: Props) => {
  const [openSettings, setOpenSettings] = useState(false);
  const handleSettingsOpen = () => setOpenSettings(true);
  const handleSettingsClose = () => setOpenSettings(false);
  return (
    <>
      <UserCanAny scope='is-admin,staff'>
        <Tooltip title='Filter'>
          <IconButton onClick={handleSettingsOpen}>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      </UserCanAny>
      <Dialog
        open={openSettings}
        onClose={handleSettingsClose}
        maxWidth='xs'
        fullWidth>
        <DialogTitle>
          <Typography>Filter Options</Typography>
        </DialogTitle>
        <DialogContent>
          <Box display='flex' gap={2}>
            {setTag && (
              <AutoCompleteGetTag
                tag={tag ?? null}
                setTag={setTag}
                school_ids={school_ids}
                event_type_ids={event_type_ids}
                station_id={station_id}
              />
            )}
            {type !== 'hot-key' && (
              <FormControlLabel
                control={
                  <Checkbox onChange={handleSelectAll} checked={allSelected} />
                }
                label='Select All'
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='flex' justifyContent='flex-end'>
            <Button onClick={handleSettingsClose}>Close</Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdminFilterOnly;
